export const getSchoolName = (program) => {
    return program.otherSchool || program.schoolName;
};
export const getFieldOfStudyName = (program) => {
    return program.otherFieldOfStudy || program.fieldOfStudyName;
};
export const getSchoolCountryCode = (program) => {
    return program.otherSchoolCountryCode || program.schoolCountryCode;
};
